import { request } from './request';

// 描述信息
export interface DescInfo {
  description: string;
  key: string;
}

// 服务机构
export interface EnvironmentOrganization {
  id: number;
  label: string;
  key: string;
  url: string;
}

// 咨询政策
export interface ConsultationPolicy {
  id: number;
  label: string;
  key: string;
  description: string;
}

// 咨询服务信息接口响应类型
export interface ConsultationServiceInfo {
  descInfo: DescInfo;
  environmentOrganization: EnvironmentOrganization[];
  consultationPolicy: ConsultationPolicy[];
}

// 通用响应类型
export interface ApiResponse<T = any> {
  code: number;
  data: T;
  msg: string;
  total?: number;
}

/**
 * 获取咨询服务信息
 */
export const getConsultationServiceInfo = () => {
  return request.get('/consultation_service/info');
};
